/* Vana theme runtime — vanilla JS ports of the Lovable React interactivity. */
(function () {
  'use strict';

  var routes = window.routes || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_url: '/cart',
  };

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    var header = document.querySelector('[data-vana-header]');
    if (!header) return;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Reveal on scroll (Reveal.tsx / motion fade-ups) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.vana-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: function () {
      return document.querySelector('[data-vana-drawer]');
    },
    open: function () {
      var d = Cart.drawer();
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var panel = d.querySelector('.vana-drawer-panel');
      if (panel) panel.focus && panel.setAttribute('tabindex', '-1');
    },
    close: function () {
      var d = Cart.drawer();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    isOpen: function () {
      var d = Cart.drawer();
      return d && d.classList.contains('is-open');
    },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        if (r.ok) return r.json();
        // Shopify answers 422 with JSON, but its bot-challenge (429) answers with HTML.
        return r.text().then(function (t) {
          var e;
          try { e = JSON.parse(t); } catch (err) { e = { status: r.status }; }
          Cart.notify(e.description || e.message || 'Något gick fel. Ladda om sidan och försök igen.');
          throw e;
        });
      });
    },
    notify: function (msg) {
      var el = document.querySelector('[data-vana-cart-notice]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-vana-cart-notice', '');
        el.setAttribute('role', 'alert');
        el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;max-width:90vw;padding:12px 20px;border-radius:9999px;background:#2b2b2b;color:#fff;font-size:14px;line-height:1.4;box-shadow:0 8px 24px rgba(0,0,0,.2);transition:opacity .3s';
        document.body.appendChild(el);
      }
      el.textContent = msg;
      el.style.opacity = '1';
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.style.opacity = '0'; }, 5000);
    },
    add: function (variantId, quantity, sellingPlan) {
      var item = { id: Number(variantId), quantity: quantity || 1 };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return Cart.request(routes.cart_add_url + '.js', { items: [item] }).then(Cart.refresh);
    },
    addMulti: function (variantIds) {
      return Cart.request(routes.cart_add_url + '.js', {
        items: variantIds.map(function (id) { return { id: Number(id), quantity: 1 }; }),
      }).then(Cart.refresh);
    },
    change: function (key, quantity) {
      return Cart.request(routes.cart_change_url + '.js', { id: key, quantity: quantity }).then(
        Cart.refresh
      );
    },
    refresh: function () {
      return fetch('/?section_id=vana-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-vana-drawer]');
          var current = Cart.drawer();
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) {
              current.classList.add('is-open');
              current.setAttribute('aria-hidden', 'false');
            }
          }
          return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-vana-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          return cart;
        });
    },
  };
  window.VanaCart = Cart;

  /* Subscribe toggle: the cart is the source of truth (rendered server-side in the drawer) */
  function subscribeOn() {
    var el = document.querySelector('[data-vana-subscribed]');
    return !!el && el.getAttribute('data-vana-subscribed') === 'true';
  }
  function setSubscribe(on) {
    var lines = Array.prototype.slice.call(document.querySelectorAll('[data-vana-line]'));
    return lines.reduce(function (p, li) {
      var plan = li.getAttribute('data-vana-plan');
      if (!plan) return p;
      return p.then(function () {
        return Cart.request(routes.cart_change_url + '.js', {
          line: Number(li.getAttribute('data-vana-line')),
          quantity: Number(li.getAttribute('data-vana-qty')),
          selling_plan: on ? Number(plan) : null,
        });
      });
    }, Promise.resolve()).then(Cart.refresh).catch(function () {});
  }

  /* ---------- Tooltips (InfoTooltip.tsx) ---------- */
  function closeTooltips(except) {
    document.querySelectorAll('.vana-tooltip.is-open').forEach(function (t) {
      if (t !== except) t.classList.remove('is-open');
    });
  }
  function initTooltips() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-vana-tooltip-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var tip = trigger.parentElement.querySelector('.vana-tooltip');
        if (tip) {
          var open = tip.classList.contains('is-open');
          closeTooltips();
          tip.classList.toggle('is-open', !open);
        }
        return;
      }
      closeTooltips();
    });
    document.addEventListener('mouseover', function (e) {
      var wrap = e.target.closest && e.target.closest('[data-vana-tooltip-wrap]');
      if (wrap) {
        var tip = wrap.querySelector('.vana-tooltip');
        if (tip) tip.classList.add('is-open');
      }
    });
    document.addEventListener('mouseout', function (e) {
      var wrap = e.target.closest && e.target.closest('[data-vana-tooltip-wrap]');
      if (wrap && !(e.relatedTarget && wrap.contains(e.relatedTarget))) {
        var tip = wrap.querySelector('.vana-tooltip');
        if (tip) tip.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeTooltips();
        if (Cart.isOpen()) Cart.close();
      }
    });
  }

  /* ---------- Global click delegation ---------- */
  function initDelegation() {
    document.addEventListener('click', function (e) {
      var t = function (sel) { return e.target.closest && e.target.closest(sel); };

      var openBtn = t('[data-vana-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.open(); return; }

      var closeBtn = t('[data-vana-cart-close]');
      if (closeBtn) { Cart.close(); return; }

      var addBtn = t('[data-vana-add]');
      if (addBtn) {
        e.preventDefault();
        addBtn.disabled = true;
        Cart.add(addBtn.getAttribute('data-vana-add'), Number(addBtn.getAttribute('data-vana-add-qty') || 1))
          .then(function () { Cart.open(); })
          .catch(function () {})
          .finally(function () { addBtn.disabled = false; });
        return;
      }

      var addMultiBtn = t('[data-vana-add-multi]');
      if (addMultiBtn) {
        e.preventDefault();
        addMultiBtn.disabled = true;
        Cart.addMulti(addMultiBtn.getAttribute('data-vana-add-multi').split(','))
          .then(function () { Cart.open(); })
          .catch(function () {})
          .finally(function () { addMultiBtn.disabled = false; });
        return;
      }

      var qtyBtn = t('[data-vana-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        Cart.change(qtyBtn.getAttribute('data-vana-qty-change'), Number(qtyBtn.getAttribute('data-qty')));
        return;
      }

      var subBtn = t('[data-vana-subscribe]');
      if (subBtn && !t('[data-vana-tooltip-trigger]')) {
        setSubscribe(subBtn.getAttribute('data-vana-subscribe') === 'on');
        return;
      }
    });

    /* PDP add-to-cart form */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-vana-atc-form]');
      if (!form) return;
      e.preventDefault();
      var variantId = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? Number(qtyInput.value) : 1;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      // Plan picker on the PDP wins; otherwise follow the cart-drawer toggle (legacy).
      var picked = form.querySelector('[name="selling_plan"]:checked');
      var plan = picked ? picked.value : subscribeOn() && form.getAttribute('data-vana-plan');
      Cart.add(variantId, qty, plan)
        .then(function () { Cart.open(); })
        .catch(function () {})
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---------- Quantity selector (PDP) ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vana-qty-btn]');
      if (!btn) return;
      var wrap = btn.closest('[data-vana-qty]');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      var display = wrap && wrap.querySelector('[data-vana-qty-value]');
      if (!input) return;
      var v = Number(input.value) + (btn.getAttribute('data-vana-qty-btn') === 'plus' ? 1 : -1);
      if (v < 1) v = 1;
      input.value = v;
      if (display) display.textContent = v;
    });
  }

  /* ---------- Carousel (<vana-carousel>) ---------- */
  var GAP = 24;
  function defineCarousel() {
    if (customElements.get('vana-carousel')) return;
    customElements.define(
      'vana-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-carousel-viewport]');
          this.track = this.querySelector('[data-carousel-track]');
          this.items = Array.prototype.slice.call(this.track ? this.track.children : []);
          this.index = 0;
          this.gap = Number(this.getAttribute('data-gap') || GAP);
          this.measure = this.measure.bind(this);
          window.addEventListener('resize', this.measure);
          this.measure();
          var self = this;
          this.querySelectorAll('[data-carousel-prev]').forEach(function (b) {
            b.addEventListener('click', function () { self.go(-1); });
          });
          this.querySelectorAll('[data-carousel-next]').forEach(function (b) {
            b.addEventListener('click', function () { self.go(1); });
          });
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.measure);
        }
        measure() {
          if (!this.viewport || !this.track) return;
          var w = this.viewport.clientWidth;
          var pv = w < 640 ? 1 : w < 1024 ? 2 : 3;
          var pvAttr = this.getAttribute('data-per-view');
          if (pvAttr === 'mobile-peek') pv = w < 640 ? 1 : w < 1024 ? 2 : 3;
          this.perView = pv;
          this.cardWidth = (w - this.gap * (pv - 1)) / pv;
          var self = this;
          this.items.forEach(function (item) {
            item.style.width = self.cardWidth + 'px';
            item.style.flexShrink = '0';
          });
          this.track.style.gap = this.gap + 'px';
          this.update(true);
        }
        maxIndex() {
          return Math.max(0, this.items.length - this.perView);
        }
        go(dir) {
          this.index = Math.min(Math.max(this.index + dir, 0), this.maxIndex());
          this.update();
        }
        update(instant) {
          var x = -this.index * (this.cardWidth + this.gap);
          this.track.style.transition = instant
            ? 'none'
            : 'transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)';
          this.track.style.transform = 'translateX(' + x + 'px)';
          var max = this.maxIndex();
          var self = this;
          this.querySelectorAll('[data-carousel-prev]').forEach(function (b) { b.disabled = self.index === 0; });
          this.querySelectorAll('[data-carousel-next]').forEach(function (b) { b.disabled = self.index >= max; });
          var progress = this.querySelector('[data-carousel-progress]');
          if (progress) {
            var pct = max === 0 ? 100 : ((this.index + 1) / (max + 1)) * 100;
            progress.style.width = pct + '%';
          }
          var counter = this.querySelector('[data-carousel-counter]');
          if (counter) {
            var pad = function (n) { return String(n).padStart(2, '0'); };
            counter.textContent = pad(this.index + 1) + ' / ' + pad(max + 1);
          }
        }
      }
    );
  }

  /* ---------- Accordion (<details> smooth open/close) ---------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest && e.target.closest('[data-vana-accordion] summary');
      if (!summary) return;
      var details = summary.parentElement;
      var content = details.querySelector('[data-accordion-content]');
      if (!content) return;
      e.preventDefault();
      var group = details.closest('[data-vana-accordion-group]');
      if (details.open) {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          content.style.height = '0px';
        });
        content.addEventListener('transitionend', function h() {
          details.open = false;
          content.style.height = '';
          content.removeEventListener('transitionend', h);
        });
      } else {
        if (group) {
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other === details) return;
            var oc = other.querySelector('[data-accordion-content]');
            if (oc) {
              oc.style.height = oc.scrollHeight + 'px';
              requestAnimationFrame(function () { oc.style.height = '0px'; });
              oc.addEventListener('transitionend', function h2() {
                other.open = false;
                oc.style.height = '';
                oc.removeEventListener('transitionend', h2);
              });
            } else {
              other.open = false;
            }
          });
        }
        details.open = true;
        var target = content.scrollHeight;
        content.style.height = '0px';
        requestAnimationFrame(function () {
          content.style.height = target + 'px';
        });
        content.addEventListener('transitionend', function h3() {
          content.style.height = 'auto';
          content.removeEventListener('transitionend', h3);
        });
      }
    });
  }

  /* ---------- UGC video (autoplay in view, mute toggle) ---------- */
  function initUgcVideo() {
    var wraps = document.querySelectorAll('[data-vana-ugc-video]');
    wraps.forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var toggle = wrap.querySelector('[data-ugc-mute]');
      if (!video) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio >= 0.5) video.play().catch(function () {});
              else video.pause();
            });
          },
          { threshold: [0, 0.5, 1] }
        );
        io.observe(video);
      }
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          toggle.querySelectorAll('[data-ugc-icon]').forEach(function (icon) {
            icon.classList.toggle('hidden', icon.getAttribute('data-ugc-icon') === (video.muted ? 'on' : 'off'));
          });
        });
      }
    });
  }

  /* ---------- Shop filters + sort ---------- */
  function initFilters() {
    var root = document.querySelector('[data-vana-filters-root]');
    if (!root) return;
    var grid = root.querySelector('[data-filter-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-filter-card]'));
    var state = { need: 'Alla', tags: [], sort: 'popular' };

    function apply() {
      var visible = [];
      cards.forEach(function (card) {
        var needs = (card.getAttribute('data-needs') || '').split('|').filter(Boolean);
        var tags = (card.getAttribute('data-tags') || '').split('|').filter(Boolean);
        var matchNeed = state.need === 'Alla' || needs.indexOf(state.need) !== -1;
        var matchTags = state.tags.every(function (t) { return tags.indexOf(t) !== -1; });
        var show = matchNeed && matchTags;
        card.hidden = !show;
        if (show) visible.push(card);
      });

      var sorted = visible.slice();
      // Base ordering = original site's product order; chosen sort applies stably on top.
      sorted.sort(function (a, b) {
        return Number(a.getAttribute('data-order') || 99) - Number(b.getAttribute('data-order') || 99);
      });
      var by = function (attr, dir) {
        return function (a, b) {
          var av = a.getAttribute(attr), bv = b.getAttribute(attr);
          var an = Number(av), bn = Number(bv);
          if (!isNaN(an) && !isNaN(bn)) return dir * (an - bn);
          return dir * String(av).localeCompare(String(bv), 'sv');
        };
      };
      switch (state.sort) {
        case 'popular':
          sorted.sort(function (a, b) {
            return (a.getAttribute('data-bestseller') === '1' ? 0 : 1) - (b.getAttribute('data-bestseller') === '1' ? 0 : 1);
          });
          break;
        case 'newest':
          sorted.sort(function (a, b) {
            return (a.getAttribute('data-new') === '1' ? 0 : 1) - (b.getAttribute('data-new') === '1' ? 0 : 1);
          });
          break;
        case 'price-asc': sorted.sort(by('data-price', 1)); break;
        case 'price-desc': sorted.sort(by('data-price', -1)); break;
        case 'name-asc': sorted.sort(by('data-name', 1)); break;
        case 'name-desc': sorted.sort(by('data-name', -1)); break;
      }
      sorted.forEach(function (card) { grid.appendChild(card); });

      var count = root.querySelector('[data-filter-count]');
      if (count) {
        var word = visible.length === 1
          ? (count.getAttribute('data-singular') || 'produkt')
          : (count.getAttribute('data-plural') || 'produkter');
        count.textContent = visible.length + ' ' + word;
      }
      var empty = root.querySelector('[data-filter-empty]');
      if (empty) empty.hidden = visible.length !== 0;

      root.querySelectorAll('[data-filter-need]').forEach(function (chip) {
        var active = chip.getAttribute('data-filter-need') === state.need;
        chip.classList.toggle('text-white', active);
        chip.classList.toggle('border-transparent', active);
        chip.classList.toggle('shadow-sm', active);
        chip.classList.toggle('border-border', !active);
        chip.classList.toggle('text-foreground/70', !active);
        chip.style.backgroundColor = active ? chip.getAttribute('data-color') : '';
      });
      root.querySelectorAll('[data-filter-tag]').forEach(function (chip) {
        var active = state.tags.indexOf(chip.getAttribute('data-filter-tag')) !== -1;
        chip.classList.toggle('text-white', active);
        chip.classList.toggle('border-transparent', active);
        chip.classList.toggle('shadow-sm', active);
        chip.classList.toggle('border-border', !active);
        chip.classList.toggle('text-foreground/70', !active);
        chip.style.backgroundColor = active ? chip.getAttribute('data-color') : '';
      });
    }

    root.addEventListener('click', function (e) {
      var needChip = e.target.closest && e.target.closest('[data-filter-need]');
      if (needChip) { state.need = needChip.getAttribute('data-filter-need'); apply(); return; }
      var tagChip = e.target.closest && e.target.closest('[data-filter-tag]');
      if (tagChip) {
        var tag = tagChip.getAttribute('data-filter-tag');
        var i = state.tags.indexOf(tag);
        if (i === -1) state.tags.push(tag); else state.tags.splice(i, 1);
        apply();
        return;
      }
    });
    var sortSelect = root.querySelector('[data-filter-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        apply();
      });
    }
    apply();
  }

  /* ---------- Day journey (expand/collapse + measured fade + CTA shift) ---------- */
  function initDayJourney() {
    var section = document.querySelector('[data-vana-day-journey]');
    if (!section) return;
    var container = section.querySelector('[data-dj-container]');
    var firstImage = section.querySelector('[data-dj-first-image]');
    var firstLink = section.querySelector('[data-dj-first-link]');
    var rest = section.querySelector('[data-dj-rest]');
    var ctaWrap = section.querySelector('[data-dj-cta-wrap]');
    var cta = section.querySelector('[data-dj-cta]');
    var ctaLabel = section.querySelector('[data-dj-cta-label]');
    var iconDown = section.querySelector('[data-dj-icon-down]');
    var iconUp = section.querySelector('[data-dj-icon-up]');
    var fade = section.querySelector('[data-dj-fade]');
    var anchor = section.querySelector('[data-dj-anchor]');
    var open = false;
    var ctaShift = 0;

    function updateClosedMetrics() {
      if (open || !container || !firstImage) return;
      if (ctaWrap) ctaWrap.style.marginBottom = '';
      var sectionRect = section.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var imageRect = firstImage.getBoundingClientRect();

      var imageBottomRel = imageRect.bottom - containerRect.top;
      var fadeStart = Math.max(0, imageBottomRel - 100);
      var fadeHeight = Math.max(1, sectionRect.bottom - (containerRect.top + fadeStart));
      var pct = Math.min(95, Math.max(20, (100 / fadeHeight) * 100));
      var surface = 'color-mix(in oklab, var(--balance) 35%, var(--background))';

      if (fade) {
        fade.style.top = fadeStart + 'px';
        fade.style.backgroundImage =
          'linear-gradient(180deg, transparent 0%, color-mix(in oklab, ' + surface + ' 55%, transparent) ' +
          pct * 0.6 + '%, ' + surface + ' ' + pct + '%, ' + surface + ' 100%)';
        fade.hidden = false;
      }

      if (ctaWrap && cta) {
        var wrapRect = ctaWrap.getBoundingClientRect();
        var ctaHeight = cta.getBoundingClientRect().height;
        var desiredTop = imageRect.bottom - ctaHeight * 0.5 - 28;
        var delta = desiredTop - wrapRect.top;
        if (Math.abs(delta) > 0.5) {
          ctaShift += delta;
          ctaWrap.style.transform = 'translateY(' + ctaShift + 'px)';
        }
        // On mobile the shifted-up button leaves its old slot (and the faded text under the image) as blank space; pull the section end up to the button.
        if (window.innerWidth < 768) {
          var excess = section.getBoundingClientRect().bottom - (desiredTop + wrapRect.height);
          if (excess > 0) ctaWrap.style.marginBottom = -excess + 'px';
        }
      }
    }

    function setOpen(v) {
      open = v;
      section.classList.toggle('dj-open', open);
      if (open) {
        if (fade) fade.hidden = true;
        if (ctaWrap) { ctaWrap.style.transform = ''; ctaWrap.style.marginBottom = ''; }
        section.classList.remove('pb-0');
        section.classList.add('pb-24', 'md:pb-32');
        ctaWrap.classList.remove('pb-12', 'md:pb-16');
        rest.style.height = '0px';
        rest.hidden = false;
        requestAnimationFrame(function () {
          rest.style.transition = 'height 0.7s cubic-bezier(0.2, 0.6, 0.2, 1), opacity 0.5s';
          rest.style.opacity = '1';
          rest.style.height = rest.scrollHeight + 'px';
        });
        rest.addEventListener('transitionend', function h(e) {
          if (e.propertyName !== 'height') return;
          rest.style.height = 'auto';
          rest.removeEventListener('transitionend', h);
        });
      } else {
        section.classList.add('pb-0');
        section.classList.remove('pb-24', 'md:pb-32');
        ctaWrap.classList.add('pb-12', 'md:pb-16');
        rest.style.height = rest.scrollHeight + 'px';
        requestAnimationFrame(function () {
          rest.style.opacity = '0';
          rest.style.height = '0px';
        });
        rest.addEventListener('transitionend', function h(e) {
          if (e.propertyName !== 'height') return;
          rest.hidden = true;
          rest.removeEventListener('transitionend', h);
          updateClosedMetrics();
        });
        requestAnimationFrame(function () {
          (anchor || section).scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      if (ctaLabel) {
        ctaLabel.textContent = open
          ? (cta.getAttribute('data-label-open') || 'Tillbaka till morgonen')
          : (cta.getAttribute('data-label-closed') || 'Följ rutinen vidare');
      }
      if (iconDown) iconDown.classList.toggle('hidden', open);
      if (iconUp) iconUp.classList.toggle('hidden', !open);
    }

    if (cta) {
      cta.addEventListener('click', function () { setOpen(!open); });
    }

    updateClosedMetrics();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(updateClosedMetrics);
      [section, firstLink, firstImage, cta].forEach(function (el) { if (el) ro.observe(el); });
    }
    window.addEventListener('resize', updateClosedMetrics);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateClosedMetrics);
    }
  }

  /* ---------- Quiz (VanaQuiz.tsx) ---------- */
  function initQuiz() {
    document.querySelectorAll('[data-vana-quiz]').forEach(function (quiz) {
      var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step]'));
      var result = quiz.querySelector('[data-quiz-result]');
      var bars = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-bar]'));
      var step = 0;
      var answers = [];

      function show() {
        steps.forEach(function (s, i) { s.hidden = i !== step || step >= steps.length; });
        var done = step >= steps.length;
        if (result) result.hidden = !done;
        bars.forEach(function (b, i) {
          b.classList.toggle('bg-clay', i < Math.min(step, steps.length));
          b.classList.toggle('bg-border', i >= Math.min(step, steps.length));
        });
        if (done && result) {
          var rec = (answers[0] || '').toLowerCase();
          var cards = result.querySelectorAll('[data-quiz-rec]');
          var matched = false;
          cards.forEach(function (el) {
            var hit = el.getAttribute('data-quiz-rec') === rec;
            el.hidden = !hit;
            if (hit) matched = true;
          });
          if (!matched && cards.length) cards[0].hidden = false;
        }
        steps.forEach(function (s) {
          var back = s.querySelector('[data-quiz-back]');
          if (back) back.hidden = step === 0;
        });
      }

      quiz.addEventListener('click', function (e) {
        var opt = e.target.closest && e.target.closest('[data-quiz-option]');
        if (opt && opt.closest('[data-vana-quiz]') === quiz) {
          answers[step] = opt.getAttribute('data-quiz-option');
          answers = answers.slice(0, step + 1);
          step += 1;
          show();
          return;
        }
        var back = e.target.closest && e.target.closest('[data-quiz-back]');
        if (back) { step = Math.max(0, step - 1); show(); return; }
        var reset = e.target.closest && e.target.closest('[data-quiz-reset]');
        if (reset) { step = 0; answers = []; show(); resetAdded(); return; }
        var add = e.target.closest && e.target.closest('[data-quiz-add]');
        if (add && !add.disabled) {
          Cart.add(add.getAttribute('data-quiz-add'), 1).then(function () {
            add.disabled = true;
            add.querySelectorAll('[data-quiz-add-label]').forEach(function (l) {
              l.classList.toggle('hidden', l.getAttribute('data-quiz-add-label') !== 'added');
            });
            add.classList.add('bg-clay');
          });
        }
      });

      function resetAdded() {
        quiz.querySelectorAll('[data-quiz-add]').forEach(function (btn) {
          btn.disabled = false;
          btn.classList.remove('bg-clay');
          btn.querySelectorAll('[data-quiz-add-label]').forEach(function (l) {
            l.classList.toggle('hidden', l.getAttribute('data-quiz-add-label') !== 'default');
          });
        });
      }

      show();
    });
  }

  /* ---------- Sticky mobile ATC (PDP) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-vana-sticky-atc="observed"]');
    var buybox = document.querySelector('[data-vana-buybox]');
    if (!bar || !buybox || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        bar.classList.toggle('translate-y-0', !visible);
        bar.classList.toggle('translate-y-full', visible);
      },
      { rootMargin: '0px 0px -40% 0px' }
    );
    io.observe(buybox);
  }

  /* ---------- Product image lightbox (native <dialog>) ---------- */
  function initLightbox() {
    var dlg = document.querySelector('[data-vana-lightbox]');
    if (!dlg || !dlg.showModal) return;
    var imgs = Array.prototype.slice.call(dlg.querySelectorAll('[data-lightbox-img]'));
    var counter = dlg.querySelector('[data-lightbox-counter]');
    var i = 0;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.hidden = k !== i; });
      if (counter) counter.textContent = i + 1 + ' / ' + imgs.length;
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-lightbox-open]');
      if (t) {
        imgs.forEach(function (im) { im.loading = 'eager'; });
        show(Number(t.getAttribute('data-lightbox-open')) || 0);
        dlg.showModal();
      } else if (e.target.closest('[data-lightbox-prev]')) show(i - 1);
      else if (e.target.closest('[data-lightbox-next]')) show(i + 1);
      else if (e.target.closest('[data-lightbox-close]') || e.target === dlg) dlg.close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(i - 1);
      if (e.key === 'ArrowRight') show(i + 1);
    });
  }

  /* ---------- Auto-scrolling strip the visitor can swipe/drag (partner logos) ---------- */
  function initAutoScroll() {
    document.querySelectorAll('[data-vana-autoscroll]').forEach(function (el) {
      var track = el.firstElementChild;
      if (!track || !track.children.length) return;
      // Content is rendered several times so the loop never runs out on wide screens.
      var perCopy = track.children.length / (Number(el.getAttribute('data-copies')) || 2);
      var duration = Number(el.getAttribute('data-vana-autoscroll')) || 20;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var pos = 0, last = 0, pausedUntil = 0, hovering = false, drag = null, moved = false;

      function period() { return track.children[perCopy].offsetLeft - track.children[0].offsetLeft; }
      function wrap(x) { var p = period(); return p > 0 ? ((x % p) + p) % p : x; }
      function hold() { pausedUntil = performance.now() + 2000; }

      // Manual scroll (touch swipe, trackpad, wheel): pause the auto motion briefly and keep looping.
      el.addEventListener('scroll', function () {
        if (Math.abs(el.scrollLeft - pos) > 2) { hold(); pos = wrap(el.scrollLeft); if (pos !== el.scrollLeft) el.scrollLeft = pos; }
      }, { passive: true });
      el.addEventListener('mouseenter', function () { hovering = true; });
      el.addEventListener('mouseleave', function () { hovering = false; drag = null; });

      // Mouse drag on desktop; touch uses native scrolling.
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        drag = { x: e.clientX, start: el.scrollLeft }; moved = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4) moved = true;
        el.scrollLeft = drag.start - dx;
      });
      window.addEventListener('pointerup', function () { drag = null; });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);

      function tick(now) {
        var dt = last ? Math.min(now - last, 100) : 0; last = now;
        if (!reduce && !hovering && !drag && now > pausedUntil) {
          pos = wrap(pos + (period() / duration) * (dt / 1000));
          el.scrollLeft = pos;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  onReady(function () {
    initHeader();
    initAutoScroll();
    initReveal();
    initDelegation();
    initTooltips();
    initQty();
    defineCarousel();
    initAccordions();
    initUgcVideo();
    initFilters();
    initDayJourney();
    initQuiz();
    initStickyAtc();
    initLightbox();
  });
})();
